<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card class="modal-adaptive">
            <div class="common-text text-center mb-2">
                {{waitingTitle}}
            </div>
            <v-flex xs12>
                <v-text-field
                    v-model="data.name"
                    placeholder="Название"
                    class="input-form-grey"
                ></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-textarea
                    v-model="data.address"
                    placeholder="Адрес"
                    class="input-form-grey input-textarea"
                    rows="5"
                    dense
                    hide-details
                ></v-textarea>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                    v-model="data.website_link"
                    placeholder="Сайт"
                    class="input-form-grey"
                ></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                    v-model="data.phone_number"
                    placeholder="Телефон"
                    class="input-form-grey"
                ></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                    v-model="data.geo_point_lat"
                    placeholder="Широта"
                    class="input-form-grey"
                    type="number"
                ></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                    v-model="data.geo_point_lon"
                    placeholder="Долгота"
                    class="input-form-grey"
                    type="number"
                ></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                    v-model="data.farewell_message"
                    placeholder="Прощальное сообщение"
                    class="input-form-grey"
                ></v-text-field>
            </v-flex>
            <v-flex class="modal-row d-flex justify-end">
                <v-btn class="btn-grey main-text" @click="cancel">
                    Отмена
                </v-btn>
                <v-btn class="btn-gradient main-text" @click="addHotel" :disabled="!disabled">
                    Сохранить
                </v-btn>
            </v-flex>
        </v-card>
        <ModalWaiting ref="modalWaiting" :title="waitingTitle"></ModalWaiting>
    </v-dialog>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";

export default {
    name: "ModalAddHotel",
    components: {ModalWaiting},
    props: {
        value: {
            type: Boolean,
        },
        hotel: {
            type: Object,
            default: null,
        },
        update: {
            type: Function,
            default: () => {},
        },
        close: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            dialog: false,
            data: {},
        }
    },
    created() {
        if (this.hotel) {
            this.data = JSON.parse(JSON.stringify(this.hotel));
        }
    },
    computed: {
        disabled() {
            return this.data.name && this.data.address && this.data.website_link && this.data.phone_number
                && this.data.geo_point_lat && this.data.geo_point_lon && this.data.farewell_message;
        },
        waitingTitle() {
            if (this.hotel) {
                return "Редактирование отеля";
            } else {
                return "Добавление отеля";
            }
        },
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
            }
        },
        hotel(val) {
            if (val) {
                this.data = JSON.parse(JSON.stringify(this.hotel));
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        cancel() {
            this.dialog = false;
            this.data = {};
            this.close();
            this.$emit('input', false);
        },
        addHotel() {
            this.$refs.modalWaiting.open();
            this.dialog = false;
            let url = "";
            let method = "post";
            if (this.hotel) {
                url = this.hotel.uid + "/";
                method = "patch";
            }
            this.$http[method]('/hotels/hotel-admin/hotels/' + url, this.data)
                .then(() => {
                    this.$refs.modalWaiting.close();
                    this.cancel();
                })
                .catch((error) => {
                    this.$refs.modalWaiting.close();
                    console.log(error);
                    this.dialog = true;
                });
        },
    }

}
</script>

<style lang="scss" scoped>
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 165px;
}
</style>